import { Reveal } from "../components/Reveal";
import { usePageMeta } from "../lib/api";

const SECTIONS = [
  {
    title: "Educational information only",
    body: "Content on this website is provided for general educational purposes. It is not an offer of insurance, a quote, a recommendation, or a guarantee of eligibility, coverage, or benefits. Any insurance product is subject to the terms, conditions, exclusions, and availability of the specific policy and carrier.",
  },
  {
    title: "Independent brokerage",
    body: "Show Me Shield Benefits LLC is an independent insurance brokerage, not an insurance carrier. We help Missouri individuals and families evaluate options from multiple carriers where available.",
  },
  {
    title: "No government affiliation",
    body: "Show Me Shield Benefits LLC is a private independent insurance brokerage and is not affiliated with, endorsed by, or operated by the State of Missouri or any state or federal government agency or program.",
  },
  {
    title: "Interactive tools",
    body: "The Build Your Shield tool and website checklists are educational. They do not determine eligibility, coverage, or provide an insurance recommendation. A licensed conversation is required before any coverage decision.",
  },
  {
    title: "Licensing",
    body: "Show Me Shield Benefits LLC operates as a licensed insurance brokerage in Missouri. License details are available upon request — call (417) 413-2882 or email showmeshield@gmail.com.",
  },
];

const Terms = () => {
  usePageMeta("Terms & Disclosures | Show Me Shield", "Terms, disclosures, and licensing information for Show Me Shield Benefits LLC.", { path: "/terms" });

  return (
    <main className="bg-paper">
      <div className="border-b border-ink/10 bg-ink">
        <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6">
          <Reveal>
            <p className="eyebrow mb-3">Legal</p>
            <h1 className="h-display text-4xl text-white sm:text-5xl">Terms &amp; Disclosures</h1>
          </Reveal>
        </div>
      </div>
      <div className="mx-auto max-w-4xl space-y-10 px-4 py-16 sm:px-6">
        {SECTIONS.map((s) => (
          <Reveal key={s.title}>
            <h2 className="font-display text-xl font-bold uppercase tracking-wide text-ink">{s.title}</h2>
            <p className="mt-3 text-base leading-relaxed text-primer">{s.body}</p>
          </Reveal>
        ))}
        <p className="text-xs text-zinc-500">
          Show Me Shield Benefits LLC &bull; ShowMeShield.com &bull; Last updated {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}
        </p>
      </div>
    </main>
  );
};

export default Terms;
